import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import ProjectBreadcrumb from './view.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { type ProjectBreadcrumbProps } from './types';
export default injectIntl(ProjectBreadcrumb);
